import 'chart.js/auto';

import { Chart } from 'react-chartjs-2';

interface Serie {
  values: number[];
  colors?: string[];
}

interface Props {
  title?: string;
  labels: string[];
  series: Serie[];
}

const MinimalLineChart = ({ labels, series }: Props) => {
  // Extract all values to find absolute min and max
  const allValues = series.flatMap((s) => s.values);

  let yMin = undefined;
  let yMax = undefined;

  if (allValues.length > 0) {
    const minVal = Math.min(...allValues);
    const maxVal = Math.max(...allValues);

    // If there's no variance (flat line), add a tiny artificial buffer so the line renders in the middle
    if (minVal === maxVal) {
      yMin = minVal - 100;
      yMax = maxVal + 100;
    } else {
      // Add a 5% buffer strictly to the min and max
      const buffer = (maxVal - minVal) * 0.05;
      yMin = minVal - buffer;
      yMax = maxVal + buffer;
    }
  }

  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        display: false,
      },
      y: {
        display: false,
        min: yMin,
        max: yMax,
      },
    },
  };

  return (
    <Chart
      type="line"
      options={options}
      data={{
        labels,
        datasets: series.map(({ values, colors }) => ({
          data: values,
          borderColor: colors,
          backgroundColor: colors,
          lineTension: 0.4,
        })),
      }}
    />
  );
};

export default MinimalLineChart;
